<template>
  <v-col cols="12" v-if="active">
    <!-- INFO -->
    <v-row no-gutters class="predmet-form__info mobile-flex-direction">
      <v-col md="4" sm="12" order="0" order-md="0"
        ><dynamic-combo
          ref="typ_predmetu"
          @valueChanged="onTypPredmetuValueChaged"
          v-model="typPredmetuItem"
          :returnObject="true"
          key="liw_filip__wiz_predmet__cb_typ_predmetu"
          data-id="liw_filip__wiz_predmet__cb_typ_predmetu"
          :cisloPredmetu="cisloPredmetu"
          outlined
        ></dynamic-combo
      ></v-col>
      <v-col md="4" sm="12" order="3" order-md="0"
        ><dodavatel
          key="liw_filip__wiz_predmet__cb_dodavatel"
          data-id="liw_filip__wiz_predmet__cb_dodavatel"
          :cisloPredmetu="cisloPredmetu"
          ref="dodavatel"
          @valueChanged="onDodavatelValueChanged"
          v-model="dodavatel"
        ></dodavatel
      ></v-col>
      <v-col md="4" sm="12" order="5" order-md="0">
        <sprostredkovatel
          optional
          ref="sprostredkovatel"
          @valueChanged="onSprostredkovatelValueChanged"
          key="liw_filip__wiz_predmet__cb_sprostredkovatel"
          data-id="liw_filip__wiz_predmet__cb_sprostredkovatel"
          :cisloPredmetu="cisloPredmetu"
        ></sprostredkovatel>
        <!-- <dynamic-combo
          optional
          ref="sprostredkovatel"
          @valueChanged="onSprostredkovatelValueChanged"
          key="liw_filip__wiz_predmet__cb_sprostredkovatel"
          data-id="liw_filip__wiz_predmet__cb_sprostredkovatel"
          clearable
          :cisloPredmetu="cisloPredmetu"
        ></dynamic-combo
      > -->
      </v-col>
      <v-col md="4" sm="12" order="1" order-md="0">
        <dynamic-combo
          ref="druhTovaru"
          key="liw_filip__wiz_predmet__cb_druh_tovaru"
          data-id="liw_filip__wiz_predmet__cb_druh_tovaru"
          :cisloPredmetu="cisloPredmetu"
          @valueChanged="onDruhTovaruValueChanged"
        />
      </v-col>
      <v-col md="4" sm="12" order="4" order-md="0">
        <dynamic-combo
          optional
          ref="predajca_dodavatela"
          @valueChanged="onPredajcaDodavatelaValueChanged"
          key="liw_filip__wiz_predmet__cb_predajca_dodavatela"
          data-id="liw_filip__wiz_predmet__cb_predajca_dodavatela"
          clearable
          :cisloPredmetu="cisloPredmetu"
        ></dynamic-combo>
      </v-col>
      <v-col md="4" sm="12" order="6" order-md="0">
        <dynamic-combo
          optional
          ref="predajca_sprostredkovatela"
          @valueChanged="onPredajcaSprostredkovatelaValueChanged"
          key="liw_filip__wiz_predmet__cb_predajca_sprostredkovatela"
          data-id="liw_filip__wiz_predmet__cb_predajca_sprostredkovatela"
          clearable
          :cisloPredmetu="cisloPredmetu"
        ></dynamic-combo>
      </v-col>
      <v-col md="4" sm="12" order="9" order-md="0"
        ><dynamic-combo
          ref="znacka"
          @valueChanged="onZnackaValueChanged"
          key="liw_filip__wiz_predmet__cb_znacky"
          data-id="liw_filip__wiz_predmet__cb_znacky"
          :cisloPredmetu="cisloPredmetu"
          @dataLoaded="$refs.nazovPredmetu.loadData()"
          outlined
        ></dynamic-combo
      ></v-col>
      <v-col md="4" sm="12" order="9" order-md="0"
        ><dynamic-combo
          ref="modely"
          @valueChanged="onModelyValueChanged"
          key="liw_filip__wiz_predmet__cb_modely"
          data-id="liw_filip__wiz_predmet__cb_modely"
          :cisloPredmetu="cisloPredmetu"
          outlined
        ></dynamic-combo
      ></v-col>
      <v-col md="4" sm="12" order="9" order-md="0">
        <dynamic-combo
          v-show="!jeTechnologia"
          ref="modely_verzie"
          @valueChanged="onModelyVerzieValueChanged"
          clearable
          key="liw_filip__wiz_predmet__cb_modely_verzie"
          data-id="liw_filip__wiz_predmet__cb_modely_verzie"
          :cisloPredmetu="cisloPredmetu"
          fulltext-filter
        ></dynamic-combo>
        <text-box
          v-show="jeTechnologia"
          label="Názov predmetu"
          :cisloPredmetu="cisloPredmetu"
          data-id="liw_filip__wiz_predmet__txt_nazov_predmetu"
          ref="nazovPredmetu"
        />
      </v-col>
      <!-- riadok 2 - automobil -->
      <template v-if="!jeTechnologia">
        <v-col md="4" sm="12" order="10" order-md="0" v-show="isControlVisible('vyrobne_cislo','liw_filip__wiz_predmet__txt_vyrobne_cislo')"
          ><text-box
            :parentReloaded="reloaded"
            ref="vyrobne_cislo"
            key="liw_filip__wiz_predmet__txt_vyrobne_cislo"
            data-id="liw_filip__wiz_predmet__txt_vyrobne_cislo"
            :cisloPredmetu="cisloPredmetu"
            :loading="vinLoading"
            @valueChanged="val => onVyrobneCisloChanged(val, true)"
            optional
            :rules="[vinRule]"
        /></v-col>
        <v-col md="4" sm="12" order="10" order-md="0"
          ><DatePicker
            label="Dátum prvej registrácie"
            ref="datum_1_registracie"
            placeholder="DD/MM/YYYY"
            @valueChanged="onDatum1RegistracieValueChanged"
            key="liw_filip__wiz_predmet__txt_datum_1_registracie"
            data-id="liw_filip__wiz_predmet__txt_datum_1_registracie"
            @dataLoaded="onDatum1RegistracieDataLoaded"
            :cisloPredmetu="cisloPredmetu"
            :max="formatDate(new Date())"
          ></DatePicker
        ></v-col>
        <v-col md="4" sm="12" order="10" order-md="0"
          ><numeric-text-box
            ref="pocet_km"
            @valueChanged="onPocetKmValueChanged"
            key="liw_filip__wiz_predmet__txt_pocet_km"
            data-id="liw_filip__wiz_predmet__txt_pocet_km"
            :cisloPredmetu="cisloPredmetu"
            suffix="km"
            :decimalPlaces="0"
            :textRight="false"
          ></numeric-text-box
        ></v-col>
      </template>
      <!-- riadok 2 - technologia -->
      <template v-else>
        <v-col md="4" sm="12" order="10" order-md="0">
          <text-box
            :parentReloaded="reloaded"
            key="liw_filip__wiz_predmet_tech__txt_vyrobne_cislo"
            data-id="liw_filip__wiz_predmet_tech__txt_vyrobne_cislo"
            :cisloPredmetu="cisloPredmetu"
            :rules="[vinRule]"
          />
        </v-col>
        <v-col md="4" sm="12" order="10" order-md="0">
          <numeric-text-box
            :parentReloaded="reloaded"
            ref="rok_vyroby"
            key="liw_filip__wiz_predmet_tech__txt_rok_vyroby"
            data-id="liw_filip__wiz_predmet_tech__txt_rok_vyroby"
            :cisloPredmetu="cisloPredmetu"
            :decimalPlaces="0"
            :textRight="false"
            :format="false"
            @valueChanged="onRokVyrobyValueChanged"
            @dataLoaded="
              () => {
                $refs.rokVyrobyAuto.loadData();
                $refs.vekPredmetuAuto.loadData();
              }
            "
            :maxValue="parseInt(new Date().getFullYear()) +1"
          />
        </v-col>
        <v-col md="4" sm="12" order="10" order-md="0">
          <numeric-text-box
            :parentReloaded="reloaded"
            ref="pocet_mh"
            key="liw_filip__wiz_predmet_tech__txt_pocet_mh"
            data-id="liw_filip__wiz_predmet_tech__txt_pocet_mh"
            :cisloPredmetu="cisloPredmetu"
            suffix="mth"
            :decimalPlaces="0"
            :textRight="false"
            @valueChanged="onPocetMhValueChanged"
          />
        </v-col>
      </template>
      <template v-if="!jeTechnologia">
        <v-col md="4" sm="12" order="11" order-md="0"
          ><text-box
            :parentReloaded="reloaded"
            ref="ecv"
            key="liw_filip__wiz_predmet__txt_ecv_povodne"
            data-id="liw_filip__wiz_predmet__txt_ecv_povodne"
            :cisloPredmetu="cisloPredmetu"
            :loading="ecvLoading"
            @valueChanged="val => onECVChanged(val, true)"
        /></v-col>
        <v-col md="4" order="0" order-md="0">
        </v-col>
        <v-col md="4" order="11" order-md="0"></v-col>
      </template>
      <v-col md="4" sm="12" order="12" order-md="0">
        <dynamic-combo
          ref="sposob_pouzitia"
          key="liw_filip__wiz_predmet__cb_sposob_pouzitia"
          data-id="liw_filip__wiz_predmet__cb_sposob_pouzitia"
          :cisloPredmetu="cisloPredmetu"
          outlined
          :clearable="true"
        ></dynamic-combo>
      </v-col>
      <v-col md="4" sm="12" style="align-self: center;" :style="isMobile ? null : { marginTop: '-12px' }" order="12" order-md="0">
        <button-group
          switchBtn
          small
          ref="ojazdene_vozidlo"
          @valueChanged="onOjazdeneVozidloValueChanged"
          key="liw_filip__wiz_predmet__btn_ojazdene_vozidlo"
          data-id="liw_filip__wiz_predmet__btn_ojazdene_vozidlo"
          :cisloPredmetu="cisloPredmetu"
        ></button-group>
      </v-col>
      <v-col md="4" sm="12" style="align-self: center;" :style="isMobile ? { marginTop: '8px' } : { marginTop: '-12px' }" order="12" order-md="0">
        <button-group
          switchBtn
          small
          ref="alternativny_predmet"
          key="liw_filip__wiz_predmet__btn_alternativny_predmet"
          data-id="liw_filip__wiz_predmet__btn_alternativny_predmet"
          @valueChanged="val => onAlternativnyPredemet(val)"
          :cisloPredmetu="cisloPredmetu"
        ></button-group>
      </v-col>
      <v-col md="12" sm="12" order="0" order-md="0">
        <check-box
            ref="podlieha_evidencii_di"
            :parentReloaded="reloaded"
            key="liw_filip__wiz_predmet__btn_podlieha_evidencii_di"
            data-id="liw_filip__wiz_predmet__btn_podlieha_evidencii_di"
            :cisloPredmetu="cisloPredmetu"
          />
      </v-col>
    </v-row>
    <!-- ROZSIRENE MOZNOSTI -->
    <div no-gutters class="predmet-form__rozsirene-moznosti">
      <v-expansion-panels class="wizard-expansion-panels px-1" flat v-model="expandPanel"
        :class="[{
                  'mb-5': !isMobile,
                  'mb-3': isMobile
                }]">
        <v-expansion-panel>
          <v-expansion-panel-header class="pa-0" :class="isMobile ? 'mt-3' : 'mt-6'"> Rozšírené možnosti </v-expansion-panel-header>
          <v-expansion-panel-content>
            <!-- AUTOMOBIL -->
            <template v-if="!jeTechnologia">
              <v-row no-gutters class="mobile-flex-direction" :class="isMobile ? 'mt-3' : 'mt-6'">
                <v-col md="4" sm="12">
                  <numeric-text-box
                    ref="objem_motora"
                    key="liw_filip__wiz_predmet__txt_objem_motora"
                    data-id="liw_filip__wiz_predmet__txt_objem_motora"
                    :cisloPredmetu="cisloPredmetu"
                    :decimalPlaces="0"
                    :textRight="false"
                  >
                    <template v-slot:append>cm<sup style="top: -0.2em">3</sup></template>
                  </numeric-text-box>
                </v-col>
                <v-col md="4" sm="12">
                  <numeric-text-box
                    ref="vykon_motora"
                    key="liw_filip__wiz_predmet__txt_vykon_motora"
                    data-id="liw_filip__wiz_predmet__txt_vykon_motora"
                    :cisloPredmetu="cisloPredmetu"
                    suffix="kW"
                    :decimalPlaces="0"
                    :textRight="false"
                  />
                </v-col>
                <v-col md="4" sm="12">
                  <numeric-text-box
                    :parentReloaded="reloaded"
                    ref="hmotnost_celkova"
                    key="liw_filip__wiz_predmet__txt_hmotnost_celkova"
                    data-id="liw_filip__wiz_predmet__txt_hmotnost_celkova"
                    :cisloPredmetu="cisloPredmetu"
                    suffix="kg"
                    :decimalPlaces="0"
                    :textRight="false"
                  />
                </v-col>
              </v-row>
              <v-row no-gutters class="mobile-flex-direction">
                <v-col md="4" sm="12" v-show="isControlVisible('pocet_naprav','liw_filip__wiz_predmet__txt_pocet_naprav')">
                  <numeric-text-box
                    ref="pocet_naprav"
                    :parentReloaded="reloaded"
                    key="liw_filip__wiz_predmet__txt_pocet_naprav"
                    data-id="liw_filip__wiz_predmet__txt_pocet_naprav"
                    :cisloPredmetu="cisloPredmetu"
                    :decimalPlaces="0"
                    :textRight="false"
                  />
                </v-col>
                <v-col md="4" sm="12">
                  <dynamic-combo
                    clearable
                    ref="typy_motora"
                    @valueChanged="onTypyMotoraValueChanged"
                    key="liw_filip__wiz_predmet__cb_typy_motora"
                    data-id="liw_filip__wiz_predmet__cb_typy_motora"
                    :cisloPredmetu="cisloPredmetu"
                    outlined
                  ></dynamic-combo>
                </v-col>
                <v-col md="4" sm="12">
                  <numeric-text-box
                    :parentReloaded="reloaded"
                    ref="pocet_sedadiel"
                    key="liw_filip__wiz_predmet__txt_pocet_sedadiel"
                    data-id="liw_filip__wiz_predmet__txt_pocet_sedadiel"
                    :cisloPredmetu="cisloPredmetu"
                    :decimalPlaces="0"
                    :textRight="false"
                  />
                </v-col>
              </v-row>
            </template>
            <!-- TECHNOLOGIA -->
            <template v-else>
              <v-row no-gutters class="mobile-flex-direction" :class="isMobile ? 'mt-3' : 'mt-6'">
                <v-col>
                  <text-box
                    :parentReloaded="reloaded"
                    key="liw_filip__wiz_predmet_tech__txt_vyrobca"
                    data-id="liw_filip__wiz_predmet_tech__txt_vyrobca"
                    :cisloPredmetu="cisloPredmetu"
                  />
                </v-col>
                <v-col>
                  <text-box
                    :parentReloaded="reloaded"
                    key="liw_filip__wiz_predmet_tech__txt_prislusenstvo"
                    data-id="liw_filip__wiz_predmet_tech__txt_prislusenstvo"
                    :cisloPredmetu="cisloPredmetu"
                  />
                </v-col>
                <v-col>
                  <dynamic-combo
                    :parentReloaded="reloaded"
                    key="liw_filip__wiz_predmet_tech__cb_krajina_povodu"
                    data-id="liw_filip__wiz_predmet_tech__cb_krajina_povodu"
                    :cisloPredmetu="cisloPredmetu"
                  />
                </v-col>
              </v-row>
              <v-row no-gutters class="mobile-flex-direction">
                <v-col>
                  <dynamic-combo
                    :parentReloaded="reloaded"
                    key="liw_filip__wiz_predmet_tech__cb_sposob_nadobudnutia"
                    data-id="liw_filip__wiz_predmet_tech__cb_sposob_nadobudnutia"
                    :cisloPredmetu="cisloPredmetu"
                  />
                </v-col>
                <v-col>
                  <check-box
                    :parentReloaded="reloaded"
                    key="liw_filip__wiz_predmet_tech__btn_tech_s_nehn"
                    data-id="liw_filip__wiz_predmet_tech__btn_tech_s_nehn"
                    :cisloPredmetu="cisloPredmetu"
                  />
                </v-col>
                <v-col>
                  <check-box
                    :parentReloaded="reloaded"
                    key="liw_filip__wiz_predmet_tech__btn_dovoz"
                    data-id="liw_filip__wiz_predmet_tech__btn_dovoz"
                    :cisloPredmetu="cisloPredmetu"
                  />
                </v-col>
              </v-row>
            </template>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <div class="predmet-form__cena">
      <v-row no-gutters class="mobile-flex-direction">
        <v-col cols="12" style="font-size: 18px; margin-left: 5px;">
          Cena
          <v-tooltip top v-if="!!cenaTooltip" max-width="350">
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="text-body-2 btn-help ml-2" v-bind="attrs" v-on="on"
                >mdi-help-circle</v-icon
              >
            </template>
            <span>{{ cenaTooltip }}</span>
          </v-tooltip>
        </v-col>
        <v-col md="4" sm="12" :class="!isMobile ? 'mt-12px' : 'mt-6px'">
          <button-group
            switchBtn
            small
            :parentReloaded="reloaded"
            ref="oc_s_dph"
            key="liw_filip__wiz_predmet__btn_oc_s_dph"
            data-id="liw_filip__wiz_predmet__btn_oc_s_dph"
            :cisloPredmetu="cisloPredmetu"
            @input="nacitajCenaTooltip()"
            v-model="ocDph"
            labelTooltip
          />
        </v-col>
      </v-row>
      <v-row no-gutters class="mobile-flex-direction" :class="!isMobile ? 'mt-25px' : 'mt-12px'">
        <v-col md="4" sm="12" v-show="isControlVisible('sadzba_dph','liw_filip__wiz_predmet__cb_sadzba_dph')">
          <dynamic-combo
            @valueChanged="reloadDPH"
            ref="sadzba_dph"
            key="liw_filip__wiz_predmet__cb_sadzba_dph"
            data-id="liw_filip__wiz_predmet__cb_sadzba_dph"
            :cisloPredmetu="cisloPredmetu"
            @dataLoaded="() => this.$refs.txtOCsDPH.loadData()"
            stopMouseDown
          />
        </v-col>
        <v-col md="4" sm="12">
          <numeric-text-box
            v-show="ocDph === 0"
            ref="txtOCsDPH"
            placeholder="0.00"
            @valueChanged="onTxtOCsDPHValueChanged"
            @dataLoaded="() => this.$refs.txtOCbezDPH.loadData()"
            label="Obstarávacia cena"
            :parentReloaded="reloaded"
            key="liw_filip__wiz_predmet__txt_oc_s_dph"
            data-id="liw_filip__wiz_predmet__txt_oc_s_dph"
            :cisloPredmetu="cisloPredmetu"
            suffix="€"
            :rules="[ocRule]"
            ignoreCompare
            stopMouseDown
          />
          <numeric-text-box
            v-show="ocDph === 1"
            @input="v => (ocBezDphValue = v)"
            ref="txtOCbezDPH"
            placeholder="0.00"
            @valueChanged="onTxtOCbezDPHValueChanged"
            label="OC bez DPH"
            key="liw_filip__wiz_predmet__txt_oc_bez_dph"
            data-id="liw_filip__wiz_predmet__txt_oc_bez_dph"
            :cisloPredmetu="cisloPredmetu"
            suffix="€"
            :rules="[ocRule]"
            ignoreCompare
            stopMouseDown
          />
        </v-col>
        <v-col md="4" sm="12">
          <numeric-text-box
            ref="cennikovaCena"
            placeholder="0.00"
            key="liw_filip__wiz_predmet__txt_cennikova_cena"
            data-id="liw_filip__wiz_predmet__txt_cennikova_cena"
            :cisloPredmetu="cisloPredmetu"
            label="Cenníková cena"
            suffix="€"
            stopMouseDown
          />
        </v-col>
      </v-row>
    </div>

    <text-box
      :v-show="false"
      data-id="liw_filip__wiz_predmet__txt_rok_vyroby"
      :cisloPredmetu="cisloPredmetu"
      ref="rokVyrobyAuto"
    />
    <numeric-text-box
      :v-show="false"
      data-id="liw_filip__wiz_predmet__txt_vek_predmetu"
      :cisloPredmetu="cisloPredmetu"
      :decimalPlaces="0"
      :textRight="false"
      ref="vekPredmetuAuto"
    />
    <v-dialog 
      :value="vins.items.length > 0" 
      overlay-color="#000"
      overlay-opacity="0.66"
      persistent
      max-width="1000"
    >
      <v-card class="dialog-card">
        <v-card-title class="d-flex justify-space-between">
          <h1 v-if="!isMobile">
            Vyberte si verziu modelu
          </h1>
          <h3 v-else>
            Vyberte si verziu modelu
          </h3>
          <v-icon style="margin-left: auto" @click="vins.items = []"
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-card-text>
          <template v-if="!isMobile">
            <v-data-table
              :headers="vins.headers"
              :items="vins.items"
              disable-pagination
              hide-default-footer
              @click:row="selectVerziaModelu"
              class="standard-table row-pointer"
            >
          </v-data-table>
          </template>
          <template v-else>
            <span class="f16 c-grayscale-100" v-html="vins.errorText"></span>
            <v-row no-gutters class="mobile-vyber-modelu-card d-flex flex-wrap mt-4" v-for="(item, index) in vins.items" :key="index"
              :class="{ 'mobile-vyber-modelu-picked-card' : item == vins.mobilePickedVehicleItem }" @click="checkMobileVerziaModelu(item)">
              <v-col v-for="header in vins.headers.filter(h => h.value !== 'brand' && h.value !== 'model')" 
                  :key="header.value" :cols="header.value == 'nazov' ? 12 : 6" :class="header.align" class="pb-4">
                  <v-row no-gutters :class="{ 'mobile-vyber-modelu-picked-icon' : header.value == 'nazov' && item == vins.mobilePickedVehicleItem }">
                    <span class="f12 gs100">{{ header.text }}</span>
                  </v-row>
                  <v-row no-gutters>
                    <span class="f14 bold white100">{{ item[header.value] }}</span>
                  </v-row>
              </v-col>
            </v-row>
            </template>
        </v-card-text>
        <v-card-actions v-if="isMobile" class="pt-0">
          <div class="mobile-vyber-bottom-div">
            <v-btn :disabled="!vins.mobilePickedVehicleItem" @click="selectVerziaModelu(vins.mobilePickedVehicleItem)" class="btn-primary" style="width: -webkit-fill-available">
              Potvrdiť
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <message-box
      v-model="warningMessage.open"
      :title="warningMessage.title"
      :text="warningMessage.text"
      :action="warningMessage.action"
      persistent
      hide-cancel
    />
  </v-col>
</template>
<script>
import DynamicCombo from '../basic/DynamicCombo.vue';
import TextBox from '../basic/TextBox.vue';
import DatePicker from '../basic/DatePicker.vue';
import ButtonGroup from '../basic/ButtonGroup.vue';
import CheckBox from '../basic/CheckBox.vue';
import NumericTextBox from '../basic/NumericTextBox.vue';
import MessageBox from '../basic/MessageBox.vue';
import Dodavatel from '../basic/Dodavatel.vue';
import { mapMutations, mapGetters } from 'vuex';
import protectedAxios from '../../auth/axios';
import Sprostredkovatel from '../basic/Sprostredkovatel.vue';
import { controlMixin } from '../../mixins/controlMixin';
import { eventBus } from '../../main';

export default {
  components: {
    DynamicCombo,
    TextBox,
    DatePicker,
    ButtonGroup,
    CheckBox,
    NumericTextBox,
    MessageBox,
    Dodavatel,
    Sprostredkovatel,
  },
  props: {
    value: Object,
    reloaded: Boolean,
    cisloPredmetu: Number,
    active: Boolean,
    isMobile: Boolean,
    newId: String,
  },
  mixins: [controlMixin],
  computed:{
    ...mapGetters(['jeDealer']),
  },
  data: () => ({
    nazovPredmetu: 'Predmet',
    typPredmetuItem: null,
    expandPanel: 0,
    jeTechnologia: 0,
    show: true,
    vinLoading: false,
    vinAlreadyChecked: false,
    ecvLoading: false,
    ecvAlreadyChecked: false,
    vinPromise: null,
    ocDph: 0,
    dodavatel: null,
    ocBezDphValue: null,
    warningMessage: {
      open: false,
      title: 'Nevybrali ste dodávateľa predmetu leasingu. Bude vybraný fiktívny dodávateľ',
      text: '',
      action: null,
    },
    cenaTooltip: '',
    vins:{
      headers:[
        { text: 'Značka', value: 'brand' , class: "min-w100px"},
        { text: 'Model', value: 'model' , class: "min-w90px"},
        { text: 'Verzia modelu', value: 'nazov' , class: "min-w160px"},
        { text: 'Objem [cm³]', value: 'capacityCcm' , class: "min-w135px"},
        { text: 'Výkon [kW]', value: 'powerKW' , class: "min-w135px"},
        { text: 'Prevodovka ', value: 'gearBoxTypeID' , class: "min-w140px"},
        { text: 'Palivo', value: 'engineTypeID' , class: "min-w120px"},
      ],
      items: [],
      mobilePickedVehicleItem: null,
    },
    oldTypPredmetu: null,
    newModel: null,
    newModelVerzia: null,
    reloadPocetKmAfterDatumLoad: false,
  }),
  methods: {
    ...mapMutations(['setJeTechnologia','openDialog','closeDialog']),
    loadAutomobil() {
      this.$refs.znacka
        .loadData()
        .then(() => this.$refs.modely?.loadData())
        .then(() => this.$refs.typy_motora.loadData())
        .then(() => this.$refs.ojazdene_vozidlo.loadData())
        .then(() => this.$refs.pocet_km.loadData())
        .then(() => this.$refs.datum_1_registracie?.loadData())
        .then(() => this.$refs.alternativny_predmet.loadData().then(() => this.onAlternativnyPredemet(this.$refs.alternativny_predmet.l_value)))
        .then(() => this.$refs.modely_verzie.loadData())
        .then(() => this.$refs.cennikovaCena.loadData())
        .then(() => this.loadObjemVykonHmotnost())
        .then(() => this.$refs.sposob_pouzitia.loadData())
        .then(() => this.$refs.druhTovaru.loadData()
          .then(()=> this.$refs.podlieha_evidencii_di.loadData()));
    },
    loadTechnologia() {
      this.$refs.znacka
        .loadData()
        .then(() => this.$refs.modely?.loadData())
        .then(() => this.$refs.nazovPredmetu.loadData())
        .then(() => this.$refs.alternativny_predmet.loadData().then(() => this.onAlternativnyPredemet(this.$refs.alternativny_predmet.l_value)))
        .then(() => this.$refs.ojazdene_vozidlo.loadData())
        .then(() => this.$refs.modely_verzie.loadData())
        .then(() => this.$refs.cennikovaCena.loadData())
        .then(() => this.loadObjemVykonHmotnost())
        .then(() => this.$refs.sposob_pouzitia.loadData())
        .then(() => this.$refs.druhTovaru.loadData()
          .then(()=> this.$refs.podlieha_evidencii_di.loadData()));
    },
    onTypPredmetuValueChaged() {
      if (this.jeTechnologia) this.loadTechnologia();
      else this.loadAutomobil();
      this.$emit('resetCheckPredmet');
    },
    onZnackaValueChanged() {
      this.$refs.modely?.loadData().then(() =>{
        if(this.newModel != null){
          this.$refs['modely'].setValueWithDirty(this.newModel);
          this.newModel = null;
        }else{
          this.$refs.modely_verzie.loadData().then(() => {
            this.$refs.typy_motora?.loadData();
            this.loadObjemVykonHmotnost();
            this.$refs.cennikovaCena.loadData();
            this.$refs.nazovPredmetu.loadData();
          })
        }
      }
      );
    },
    onDodavatelValueChanged() {
      //ak je fiktivny tak nebude loadovat
      if (this.dodavatel !== 8)
        this.$refs.typ_predmetu.loadData()
          .then(() => 
              this.onTypPredmetuValueChaged()
          );

      this.$refs.predajca_dodavatela.loadData();
    },
    onSprostredkovatelValueChanged() {
      this.$refs.predajca_sprostredkovatela.loadData();
    },
    onModelyValueChanged() {
      this.$refs.modely_verzie.loadData().then(() =>{
        if(this.newModelVerzia != null){
          this.$refs['modely_verzie'].setValueWithDirty(this.newModelVerzia);
          this.newModelVerzia = null;
        }else{
          this.loadObjemVykonHmotnost();
          this.$refs.cennikovaCena.loadData();
          this.$refs.nazovPredmetu.loadData();
        }
      })
    },
    onTxtOCsDPHValueChanged() {
      this.$refs.txtOCbezDPH.loadData();
      this.checkDodavatel();
    },
    onTxtOCbezDPHValueChanged() {
      this.$refs.txtOCsDPH.loadData();
      this.checkDodavatel();
    },
    onTypyMotoraValueChanged() {
      this.$refs.modely_verzie.loadData().then(() => this.loadObjemVykonHmotnost());
    },
    onOjazdeneVozidloValueChanged() {
      this.$refs?.datum_1_registracie
        ?.loadData()
        .then(() => this.$refs.modely_verzie.loadData())
        .then(() => this.loadObjemVykonHmotnost());
      this.$refs?.pocet_km?.loadData();
      this.$refs?.pocet_mh?.loadData();
      this.$refs?.rok_vyroby?.loadData();
      this.$emit('resetCheckPredmet');
    },
    onDatum1RegistracieValueChanged() {
      this.$refs.ojazdene_vozidlo
        .loadData()
        .then(() => this.$refs.modely_verzie.loadData())
        .then(() => this.loadObjemVykonHmotnost())
        .then(() => this.reloadDatum1RegistracieDependents(true))
        .then(() => {
          this.$emit('resetCheckPredmet');
        });
    },
    onDatum1RegistracieDataLoaded() {
      if (!this.reloadPocetKmAfterDatumLoad) {
        return this.reloadDatum1RegistracieDependents(false);
      }

      this.reloadPocetKmAfterDatumLoad = false;
      return this.reloadDatum1RegistracieDependents(true);
    },
    reloadDatum1RegistracieDependents(reloadPocetKm) {
      return Promise.all([
        this.$refs.rokVyrobyAuto?.loadData?.(),
        this.$refs.vekPredmetuAuto?.loadData?.(),
        !this.jeTechnologia ? this.$refs.cennikovaCena?.loadData?.() : Promise.resolve(),
        reloadPocetKm ? this.$refs?.pocet_km?.loadData?.() : Promise.resolve(),
      ]);
    },
    onPocetKmValueChanged() {
      this.$refs.ojazdene_vozidlo.loadData();
      this.$emit('resetCheckPredmet');
    },
    onPocetMhValueChanged() {
      this.$refs.ojazdene_vozidlo.loadData();
      this.$emit('resetCheckPredmet');
    },
    onRokVyrobyValueChanged() {
      this.$refs.ojazdene_vozidlo.loadData()
        .then(() => {
          this.$refs.rokVyrobyAuto.loadData();
          this.$refs.vekPredmetuAuto.loadData();
          this.$emit('resetCheckPredmet');
        });
    },
    refreshModelyVerzieFromParent() {
      return this.$refs.modely_verzie.loadData().then(() => this.onModelyVerzieValueChanged());
    },
    onModelyVerzieValueChanged() {
      if (!this.jeTechnologia) {
        this.oldTypPredmetu = this.$refs.typ_predmetu.currentValue;
        this.$refs.typ_predmetu.loadData()
        .then(async () => {
          if(this.oldTypPredmetu?.valueMember != this.$refs.typ_predmetu.currentValue?.valueMember){
            this.onTypPredmetuValueChaged()
              let _dialog = {
                persistent: true,
                header: `<span class="gs100 f16">Upozornenie</span>`,
                text: `<span>Typ predmetu sa nastavil podľa verzie modelu.</span>`,
                closeIcon: {
                  value: true,
                  func: null
                },
                primaryBtn: {
                  text: `Zatvoriť`,
                  func: null,
                },
              };
              _dialog.primaryBtn.func = () => {
                this.closeDialog();
              };
              _dialog.closeIcon.func = () => {
                this.closeDialog();
              };

              
              this.openDialog(_dialog);
            }else{
              await this.$refs.nazovPredmetu.loadData();
              await this.$refs.typy_motora.loadData();
              await this.$refs.cennikovaCena.loadData();
              await this.loadObjemVykonHmotnost();
            }
          }
        );
      }
    },
    onVyrobneCisloChanged(val, vinInputChanged) {
      // console.log(
      //   'onVyrobneCisloChanged',
      //   this.vinLoading,
      //   this.vinAlreadyChecked,
      //   vinInputChanged
      // );
      if (vinInputChanged) {
        this.vinAlreadyChecked = false;
      }
      if (this.vinLoading || this.vinAlreadyChecked) {
        return;
      }

      if (this.$refs['vyrobne_cislo'].$refs['control'].validate()) {
        if (!val || val.length < 17) {
          this.$emit('vinChecked');
          return;
        }

        this.vinLoading = true;
        this.$emit('vinChecking');
        this.vinPromise = protectedAxios
          .get(
            `/pripady/${this.newId}/predmety/${
              this.cisloPredmetu
            }/check-vin-car-catalog?vin=${val}`
          )
          .then(res => {
            this.warningMessage.title = '';
            let result = true;
            if (res.data.vinCheck.error > 0) {
              this.warningMessage.title = res.data.vinCheck.errorText;
              if (this.isMobile) {
                this.vins.errorText = res.data.vinCheck.errorText.replace(/ako\s(.*?),/, function(match, p1) {
                    return `ako <span style="color: white;">${p1}</span>,`;
                });
              } else {
                this.warningMessage.open = true;
              }
              result = false;
            }
            if (this.jeDealer && res.data.registerVozidiel.error > 0) {
              this.warningMessage.title = `${this.warningMessage.title}\n\n${res.data.registerVozidiel.errorText}`;
              result = false;
              if (!this.isMobile) {
                this.warningMessage.open = true;
              }
            }
            this.vins.items = res.data.vins;
            this.oldTypPredmetu = this.$refs.typ_predmetu.currentValue;
            this.$refs.typ_predmetu.loadData()
            .then(() => {
              if(this.oldTypPredmetu?.valueMember != this.$refs.typ_predmetu.currentValue?.valueMember){
                let _dialog = {
                  persistent: true,
                  header: `<span class="gs100 f16">Upozornenie</span>`,
                  text: `<span>Typ predmetu sa nastavil podľa verzie modelu.</span>`,
                  closeIcon: {
                    value: true,
                    func: null
                  },
                  primaryBtn: {
                    text: `Zatvoriť`,
                    func: null,
                  },
                };
                _dialog.primaryBtn.func = () => {
                  this.closeDialog();
                };
                _dialog.closeIcon.func = () => {
                  this.closeDialog();
                };

                
                this.openDialog(_dialog);
              }
              this.reloadPocetKmAfterDatumLoad = true;
              this.onTypPredmetuValueChaged()
              this.oldTypPredmetu = null;
            })
            this.vinLoading = false;
            this.vinAlreadyChecked = true;
            this.$emit('vinChecked');
            this.vinPromise = null;
            return result;
          })
          .catch(e => (this.vinLoading = false));
      }
    },
    async onECVChanged(val, ecvInputChanged){
      if (ecvInputChanged) {
        this.ecvAlreadyChecked = false;
      }
      if (this.ecvLoading || this.ecvAlreadyChecked) {
        return;
      }

      if (val != null && val != '') {
        this.ecvLoading = true;
        this.ecvPromise = await protectedAxios
          .get(
            `/pripady/${this.newId}/predmety/${
              this.cisloPredmetu
            }/check-ecv-car-catalog?ecv=${val}`
          )
          .then(async res => {
            this.warningMessage.title = '';
            let result = true;
            if (res.data.error > 0) {
              this.warningMessage.title = res.data.errorText;
              result = false;
              this.warningMessage.open = true;
            }else{
              await this.$refs['vyrobne_cislo'].loadData().then(_ => {
                let vin = this.$refs['vyrobne_cislo'].stringValue;
                if(vin){
                  this.onVyrobneCisloChanged(vin,true)
                }
              });
            }
            this.ecvLoading = false;
            this.ecvAlreadyChecked = true;
            this.ecvPromise = null;
            return result;
          })
          .catch(e => (this.ecvLoading = false));
        }
    },
    onPredajcaSprostredkovatelaValueChanged() {
      this.$refs.predajca_dodavatela.loadData();
    },
    onPredajcaDodavatelaValueChanged() {
      this.$refs.predajca_sprostredkovatela.loadData();
    },
    loadObjemVykonHmotnost() {
      this.$refs.objem_motora?.loadData();
      this.$refs.vykon_motora?.loadData();
      this.$refs.hmotnost_celkova?.loadData();
      this.$refs.pocet_sedadiel?.loadData();
    },
    onDruhTovaruValueChanged(){
      this.$refs.podlieha_evidencii_di.loadData();
    },
    reload() {
      this.$nextTick(() => {
        this.$refs.sprostredkovatel
        .loadData()
        .then(() => this.$refs.dodavatel.loadData())
        .then(() => this.$refs.predajca_dodavatela.loadData())
        .then(() => this.$refs.predajca_sprostredkovatela.loadData())
        .then(() => this.$refs.typ_predmetu.loadData())
        .then(() => this.$refs.sadzba_dph.loadData())
        .then(() => this.onTypPredmetuValueChaged())
      });

    },
    checkDodavatel() {
      if (!this.dodavatel) {
        this.warningMessage.title =
          'Nevybrali ste dodávateľa predmetu leasingu. Bude vybraný fiktívny dodávateľ';
        this.warningMessage.open = true;
        this.$refs.dodavatel.setIdDodavatela(8);
      }
    },
    ocRule(v) {
      const num = parseFloat(String(v).replace(/,/g, '.'));
      if (!num && num !== 0) return true;
      if (num <= 0) return 'Hodnota OC musí byť väčšia ako 0!';
      return true;
    },
    vinRule(v) {
      if(!this.jeTechnologia){
        if (v?.length > 0 && v?.length != 17) return 'VIN musí obsahovať 17 znakov.';
        if (!/^[a-hj-npr-zA-HJ-NPR-Z0-9]*$/.test(v)) return 'Nesprávny formát VIN.';
      }else{
        if (v?.length > 0 && v?.length > 30) return 'VIN musí obsahovať maximálne 30 znakov.';
      }
      return true;
    },
    async beforeStep() {
      // if (!this.ocBezDphValue) {
      //   await this.$refs.txtOCbezDPH.loadData();
      // }
      if (this.$refs.vyrobne_cislo && !this.jeTechnologia) {
        this.onVyrobneCisloChanged(this.$refs.vyrobne_cislo.getCacheValue());
        if (this.vinPromise !== null && !this.vinIsAlreadyChecked) {
          return await this.vinPromise;
        }
      }

      if (!this.dodavatel) {
        await new Promise((res, rej) => {
          this.warningMessage.title =
            'Nevybrali ste dodávateľa predmetu leasingu. Bude vybraný fiktívny dodávateľ';
          this.warningMessage.open = true;
          this.$refs.dodavatel.setIdDodavatela(8);
          this.warningMessage.action = () => res(true);
        });
      }

      if(this.jeTechnologia == 0 && this.$refs.cennikovaCena.getValue() == null || this.$refs.cennikovaCena.getValue() == 0){
        let _dialog = {
              persistent: true,
              header: `<span class="gs100 f16">Upozornenie</span>`,
              text: `<span>Nezadali ste <span class="f16 white100">cenníkovú cenu</span> pre korektný výpočet poistenia.<br/>Poistenie bude vypočítané z <span class="f16 white100">kúpnej ceny</span>.</span>`,
              closeIcon: {
                value: true,
                func: null
              },
              primaryBtn: {
                text: `Pokračovať`,
                func: null,
              },
              secondaryBtn: {
                text: `Doplniť cenníkovú cenu`,
                func: null,
              },
            };
            return new Promise((res, rej) => {
              _dialog.primaryBtn.func = () => {
                this.closeDialog();
                res(true);
              };
              _dialog.secondaryBtn.func = () => {
                this.closeDialog();
                res(false);
              };
              _dialog.closeIcon.func = () => {
                this.closeDialog();
                res(false);
              };

              
              this.openDialog(_dialog);
            });
      }

      return Promise.resolve(true);
    },
    reloadDPH() {
      if (this.ocDph == 1) {
        this.$refs.txtOCbezDPH.loadData();
      } else {
        this.$refs.txtOCsDPH.loadData();
      }
    },
    nacitajCenaTooltip() {
      this.cenaTooltip = this.$refs['oc_s_dph'].getTooltip;
    },
    formatDate(date) {
      if (date != null) {
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        if (month.toString().length < 2) month = '0' + month;
        if (day.toString().length < 2) day = '0' + day;
        return year + '-' + month + '-' + day;
      } else {
        return null;
      }
    },
    selectVerziaModelu(item) {
      if(this.$refs['znacka'].currentValue == null || this.$refs['znacka'].currentValue == 118){
        this.newModel = item.id_modelu;
        this.newModelVerzia = item.vehicleID;
        this.$refs['znacka'].setValueWithDirty(item.id_znacky).then(_ => {
              this.vins.items = [];
        })
      }else{
        this.$refs['modely_verzie'].setValueWithDirty(item.vehicleID).then(_ => {
          this.onModelyVerzieValueChanged()
          this.vins.items = [];
        })
      }
    },
    checkMobileVerziaModelu(item) {
      if (this.vins.mobilePickedVehicleItem == item) {
        this.vins.mobilePickedVehicleItem = null
      } else {
        this.vins.mobilePickedVehicleItem = item
      }
    },
    onAlternativnyPredemet(value){
      let typ = this.$refs.alternativny_predmet.l_data.find(v=> v.valueMember == value);
      this.$emit('changeSufixPredmetu',typ?.displayMember + ' predmet');
    },
  },
  watch: {
    typPredmetuItem(item) {
      if (item) {
        this.jeTechnologia = item.je_technologia;
        this.setJeTechnologia(this.jeTechnologia);
      }
    },
    reloaded(val) {
      if (val) this.reload();
    },
  },
  mounted() {
    eventBus.$on('reloadSadzba', () => this.$refs.sadzba_dph.loadData());
    if (this.reloaded) this.reload();
  },
};
</script>
